// src/Components/Forms/Financement/Salam/Validation/Tab1.tsx
import React from 'react';
import { Box, Grid } from '@mui/material';
import { Form } from 'antd';
import InputForm from '../../../../InputT';
import SearchModal from '../../../../SearchModal';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';

// Paramètres de recherche (inchangés)
let searchSalam: ParamsPicklist = {
  CodeAgence: '',
  Table: 'ParamsSalam',
  Colonne1: 'CodeSalam',
  Colonne2: 'LibelleSalam',
  Colagence: '101',
  Choix: 22,
};

let searchGes: ParamsPicklist = {
  CodeAgence: '',
  Table: 'GESTIONNAIRE',
  Colonne1: 'CODGES',
  Colonne2: 'LIBELLE',
  Colagence: '101',
  Choix: 22,
};

let searchClient: ParamsPicklist = {
  CodeAgence: '',
  Table: 'CLIENT',
  Colonne1: 'NUMCLI',
  Colonne2: 'NOMCLI',
  Colagence: '101',
  Choix: 22,
};

let searchUnite: ParamsPicklist = {
  CodeAgence: '',
  Table: 'Unite',
  Colonne1: 'CodeUnite',
  Colonne2: 'Libelle',
  Colagence: '101',
  Choix: 22,
};

let searchActif: ParamsPicklist = {
  CodeAgence: '',
  Table: 'Actif',
  Colonne1: 'CodeActif',
  Colonne2: 'Designation',
  Colagence: '101',
  Choix: 22,
};

let searchNature: ParamsPicklist = {
  CodeAgence: 'ACTIVITE',
  Table: 'LIB',
  Colonne1: 'CODLIB',
  Colonne2: 'LIBELL',
  Colagence: 'RUBRIQ',
  Choix: 22,
};

interface Tab1Props {
  form?: any;
}

const Tab1 = (props: Tab1Props) => {
  const disabled = true; // lecture seule

  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={'85%'} position={'absolute'}>
        <Box className="border-left" p={1}>
          <Grid container spacing={0}>
            {/* Ligne 1 : Type Salam + Numéro Demande */}
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Type Salam"
                label="Type Salam"
                name="CodeSalam"
                form={props.form}
                Parametre={searchSalam}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputForm
                width={7}
                label="Numéro Demande"
                name="NumeroDemande"
                disabled={disabled}
                type="text"
              />
            </Grid>

            {/* Ligne 2 : Client + Compte règlement */}
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Client"
                label="Client"
                name="NUMCLI"
                form={props.form}
                Parametre={searchClient}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputForm
                width={7}
                label="Compte règlement"
                name="CPTREGLEMENT"
                disabled={disabled}
                type="text"
              />
            </Grid>

            {/* Ligne 3 : Gestionnaire + Activité */}
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Gestionnaire"
                label="Gestionnaire"
                name="CODGEA"
                form={props.form}
                Parametre={searchGes}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Secteur d'activité"
                label="Activité"
                name="CODACTIVE"
                form={props.form}
                Parametre={searchNature}
                disabled={disabled}
                notRequired
              />
            </Grid>

            {/* Ligne 4 : Produit + Unité */}
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Actif"
                label="Actif"
                name="CodeActif"
                form={props.form}
                Parametre={searchActif}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchModal
                width={7}
                Titre="Recherche Unité"
                label="Unité"
                name="Unite"
                form={props.form}
                Parametre={searchUnite}
                disabled={disabled}
              />
            </Grid>

            {/* Ligne 5 : Quantité + Prix unitaire + Montant demandé */}
            <Grid item xs={12} md={4}>
              <InputForm
                width={7}
                label="Quantité"
                name="Quantite"
                disabled={disabled}
                type="number"
                money
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InputForm
                width={7}
                label="Prix unitaire"
                name="PrixUnitaire"
                disabled={disabled}
                type="number"
                money
                notRequired
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InputForm
                width={7}
                label="Montant demandé"
                name="MontantDemande"
                disabled={true}
                type="number"
                money
              />
            </Grid>

            {/* Ligne 6 : Frais de service (seul) */}
            <Grid item xs={12} md={4}>
              <InputForm
                width={7}
                label="Frais service"
                name="FraisService"
                disabled={true}
                type="number"
                notRequired
                money
              />
            </Grid>

            {/* Ligne 7 : Date livraison + Objet */}
            <Grid item xs={12} md={4}>
              <InputForm
                width={7}
                label="Date livraison prévue"
                name="DateLivraison"
                disabled={disabled}
                type="date"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InputForm
                width={7}
                label="Objet"
                name="CODOBJECT"
                disabled={disabled}
                type="text"
                notRequired
              />
            </Grid>

            {/* Ligne 8 : Lieu livraison + Commentaire */}
            <Grid item xs={12} md={6}>
              <InputForm
                width={5}
                label="Lieu de livraison"
                name="LieuLivraison"
                disabled={disabled}
                type="text"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputForm
                width={7}
                label="Commentaire"
                name="CommentaireDemande"
                disabled={disabled}
                type="TextArea"
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

export default Tab1;